import WarehouseShopProductData, {
    IWarehouseShopProductData
} from "@/http/data/warehouse-shop-product-data";

import WarehouseShopOrderNoteData, {
    IWarehouseShopOrderNoteData
} from "@/http/data/warehouse-shop-order-note-data";

export interface IWarehouseShopOrderItemData {
    id: number;
    product_id: number;
    requested: number|string;
    loaded?: null|number|string;
    load_timestamp?: null|string;
    delivered?: null|number|string;
    deliver_timestamp?: null|string;
    returned?: null|number|string;
    return_timestamp?: null|string;
    retoured?: null|number|string;
    retour_timestamp?: null|string;
    product?: null|IWarehouseShopProductData;
    notes?: IWarehouseShopOrderNoteData[];
}

function nullableNumber(value: null|undefined|number|string): null|number {
    if (value === null || value === undefined || value === "") return null;

    const parsed = Number(value);

    return Number.isFinite(parsed) ? parsed : null;
}

export default class WarehouseShopOrderItemData {
    public id: number;
    public product_id: number;
    public requested: number;
    public loaded: null|number;
    public load_timestamp: null|string;
    public delivered: null|number;
    public deliver_timestamp: null|string;
    public returned: null|number;
    public return_timestamp: null|string;
    public retoured: null|number;
    public retour_timestamp: null|string;
    public product: null|WarehouseShopProductData;
    public notes: WarehouseShopOrderNoteData[];

    constructor(data: IWarehouseShopOrderItemData) {
        this.id = Number(data.id);
        this.product_id = Number(data.product_id);
        this.requested = Number(data.requested ?? 0);
        this.loaded = nullableNumber(data.loaded);
        this.load_timestamp = data.load_timestamp ?? null;
        this.delivered = nullableNumber(data.delivered);
        this.deliver_timestamp = data.deliver_timestamp ?? null;
        this.returned = nullableNumber(data.returned);
        this.return_timestamp = data.return_timestamp ?? null;
        this.retoured = nullableNumber(data.retoured);
        this.retour_timestamp = data.retour_timestamp ?? null;
        this.product = data.product
            ? new WarehouseShopProductData(data.product)
            : null;
        this.notes = (data.notes ?? []).map(
            note => new WarehouseShopOrderNoteData(note)
        );
    }
}